import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { Flex, Spinner } from "@chakra-ui/react";
import { auth } from "../firebase";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [status, setStatus] = useState<"checking" | "authed" | "guest">(
    "checking",
  );

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setStatus(user ? "authed" : "guest");
    });
    return unsubscribe;
  }, []);

  if (status === "checking") {
    return (
      <Flex minH="60vh" align="center" justify="center">
        <Spinner color="rs.red" />
      </Flex>
    );
  }

  if (status === "guest") {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
